
// You can write more code here

/* START OF COMPILED CODE */

import { LevelManager } from "~/js/game/LevelManager";
import Powerup from "../../game/powerups/Powerup";
/* START-USER-IMPORTS */
import { Sounds } from "../../sounds";
/* END-USER-IMPORTS */

export default class RoadRunnerPowerup extends Powerup {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  public duration:number = 1000;
  public speedModifier:number = 2;
  protected affectsPlayerSpeed: boolean = true;

  public override ApplyPowerup(levelManager: LevelManager): void {
    super.ApplyPowerup(levelManager);
  }

  update(playerX: number, playerY: number, time: number, deltaTime: number) {
    super.update(playerX, playerY, time, deltaTime);

  }

  modifyPlayerSpeed(vx: number, vy: number): { vx: number; vy: number } {
    return {vx:vx*this.speedModifier, vy:vy*this.speedModifier};
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
